﻿import {kebabCase} from "@2d-front-monorepo/core";
import ApprovalStatus from "../enums/ApprovalStatus";
import {AttachmentStatus, AttachmentType, ParkingPrebookingAvailabilityType, PermitStatusType} from "../index";
import {PermitEntityResult} from "../types/PermitEntityResult";

export function approvalStatusName<T>(permit: PermitEntityResult<T>): string {
	return kebabCase(ApprovalStatus[permit.status]);
}

export function approvalStatusLabel<T>(permit: PermitEntityResult<T>): string {
	if (permit.status == ApprovalStatus.Undefined) {
		return "";
	}

	return `approval-status--${approvalStatusName(permit)}`;
}

export function permitStatusName(permitStatus: PermitStatusType):string {
	return kebabCase(PermitStatusType[permitStatus]);
}

export function permitStatusLabel(permitStatus: PermitStatusType): string {
	if (permitStatus == PermitStatusType.Undefined) {
		return "";
	}

	return `permit-status--${permitStatusName(permitStatus)}`;
}

export function attachmentStatusName(attachmentStatus: AttachmentStatus): string {
	return kebabCase(AttachmentStatus[attachmentStatus]);
}

export function attachmentStatusLabel(attachmentStatus: AttachmentStatus): string {
	if (attachmentStatus == AttachmentStatus.Undefined) {
		return "";
	}

	return `attachment-status--${attachmentStatusName(attachmentStatus)}`;
}

export function attachmentTypeName(attachment: AttachmentType): string {
	return kebabCase(AttachmentType[attachment]);
}

export function attachmentTypeLabel(attachment: AttachmentType): string {
	if (attachment == AttachmentType.Undefined) {
		return "";
	}

	return `attachment-type--${attachmentTypeName(attachment)}`;
}

export function parkingPrebookingAvailabilityTypeName(availabilityType: ParkingPrebookingAvailabilityType): string {
	return kebabCase(ParkingPrebookingAvailabilityType[availabilityType]);
}

export function parkingPrebookingAvailabilityTypeLabel(availabilityType: ParkingPrebookingAvailabilityType): string {
	if (availabilityType == ParkingPrebookingAvailabilityType.Undefined) {
		return "";
	}

	return `availability-type--${parkingPrebookingAvailabilityTypeName(availabilityType)}`;
}
